var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"left"},[_vm._t("back")],2),_c('div',{staticClass:"title"},[_vm._t("title")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }